module.exports = __webpack_public_path__ + "static/burrito-con-pollo-adobado-1-2a66b11e7afea7feffd0bd98662f44a2.jpg";